import React from "react";
import Column from "Components/Column";
import PropTypes from "prop-types";
import { Icon, check } from "Icons/index";
import Button from "Components/button/Button";

import { t } from "i18next";
import TranslatedString from "Components/TranslatedString";

import cx from "classnames";
import s from "./congratulations.scss";

const ContextTypes = {
  router: PropTypes.object,
};

class CongratulationsScreen extends React.Component {
  constructor(props) {
    super(props);
    this.returnToList = this.returnToList.bind(this);
  }

  returnToList() {
    this.props.history.push("/domains");
  }

  render() {
    return (
      <div className={cx("orderPage", s.congratulations)}>
        <div className={cx("sectionTitle", "titleFP")}>{t("order.add.congratulation.title")}</div>

        <div className="wrapScrollFP">
          <div className={cx("infoFP", s.wrapInfo)}>
            <div className={s.subtitle}>{t("order.add.congratulation.subtitle")}</div>

            {/* <div className={s.text}>
              <TranslatedString
                subs={{
                  code: this.props.orderCode
                }}
              >
                order.add.congratulation.orderNumber
              </TranslatedString>
            </div> */}

            <div className={s.text}>
              <TranslatedString
                subs={{
                  email: this.props.formData.email_address,
                }}
              >
                order.add.congratulation.desc
              </TranslatedString>
            </div>

            <Button color="green" onClick={this.props.showWHMCSInvoice} loading={this.props.loadingInvoiceUrl}>
              button.see.proforma
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

CongratulationsScreen.contextTypes = ContextTypes;

export default CongratulationsScreen;
